import { routerMain } from 'constants/routerMain';
import { routerPathMain } from 'constants/routerPathMain';
import { lazy } from 'react';

const CategoryDocument = lazy(() => import('features/category-document/document-type/pages/CategoryDocument'));
const CategoryDocumentAddEdit = lazy(() =>
    import('features/category-document/document-type/pages/CategoryDocumentAddEdit')
);
const CategoryDocumentPdfAddEdit = lazy(() =>
    import('features/category-document/document-type/pages/CategoryDocumentPdfAddEdit')
);
const CategoryDocumentPosition = lazy(() =>
    import('features/category-document/document-type/pages/CategoryDocumentPosition')
);

const DocumentRouter = [
    // document
    {
        path: routerMain.CATEGORY_DOCUMENT,
        exact: true,
        component: CategoryDocument,
    },
    {
        path: `${routerMain.CATEGORY_DOCUMENT}${routerPathMain.ADD}`,
        exact: true,
        component: CategoryDocumentAddEdit,
    },
    {
        path: `${routerMain.CATEGORY_DOCUMENT}${routerPathMain.EDIT}/:uuid`,
        exact: true,
        component: CategoryDocumentAddEdit,
    },
    {
        path: `${routerMain.CATEGORY_DOCUMENT}${routerPathMain.ADD}${routerPathMain.PDF}`,
        exact: true,
        component: CategoryDocumentPdfAddEdit,
    },
    {
        path: `${routerMain.CATEGORY_DOCUMENT}${routerPathMain.EDIT}${routerPathMain.PDF}/:uuid`,
        exact: true,
        component: CategoryDocumentPdfAddEdit,
    },
    {
        path: `${routerMain.CATEGORY_DOCUMENT}${routerPathMain.POSITION}/:uuid`,
        exact: true,
        component: CategoryDocumentPosition,
    },
];
export default DocumentRouter;
